import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import Loader, { ErrorBox } from '../../components/Loader.jsx';
import TaskForm from './TaskForm.jsx';
import { TasksAPI } from '../../lib/api';
import { buildPath } from '../../config';

export default function TaskEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [task, setTask] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    TasksAPI.retrieve(id)
      .then(setTask)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [id]);

  const onSubmit = async (payload) => {
    setSubmitting(true);
    setError(null);
    try {
      await TasksAPI.update(id, payload);
      navigate(buildPath.taskDetails(id));
    } catch (e) {
      setError(e);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <Loader />;
  if (!task) return <ErrorBox error={error || new Error('Task not found.')} />;

  return (
    <>
      <PageHeader title={`Edit: ${task.title}`} />
      <ErrorBox error={error} />
      <TaskForm
        initial={{
          title:           task.title,
          description:     task.description || '',
          start_date:      task.start_date || '',
          end_date:        task.end_date || '',
          estimated_hours: task.estimated_hours ?? '',
          urgency:         task.urgency || 'default',
          team:            task.team || 'individual',
          status:          task.status || 'assigned',
          users:           (task.users && task.users.length)
            ? task.users
            : (task.assignees || []).map((a) => a.id),
          assignees:       task.assignees || [],
        }}
        onSubmit={onSubmit}
        submitting={submitting}
      />
    </>
  );
}
